module.exports = "/images/agent-premium-content.png?8e33430d3a35931d25092f220f626911";